import { isFunction } from '../utils';
import React, { useCallback, useRef, useState } from 'react';

const useRefState = <T>(
    defaultValue: T
): [T, (v: React.SetStateAction<T>) => void, React.MutableRefObject<T>] => {
    const [state, setState] = useState<T>(defaultValue);
    const stateRef = useRef<T>(defaultValue);

    const handleStateChange = useCallback((value: React.SetStateAction<T>) => {
        if (isFunction(value)) {
            setState((prevState) => {
                const newState = value(prevState);
                stateRef.current = newState;
                return newState;
            });
        } else {
            setState(value);
            stateRef.current = value;
        }
    }, []);

    return [state, handleStateChange, stateRef];
};

export default useRefState;
